import { COLORS } from 'ethos-design-system'

type HeadingColor = keyof typeof headingColorMap

const headingColorMap = {
  cypress: COLORS.BRAND_CYPRESS,
  gray: COLORS.GRAY_SECONDARY,
  grayPrimary: COLORS.GRAY_PRIMARY,
  forest: COLORS.BRAND_FOREST,
  white: COLORS.WHITE,
}

export const resolveHeadingColor = (headingColor?: string): string => {
  if (headingColor !== undefined) {
    headingColor = `${headingColor
      ?.charAt(0)
      .toLowerCase()}${headingColor?.slice(1)}`
  }

  const color =
    headingColor && headingColor in headingColorMap
      ? headingColorMap[headingColor as HeadingColor]
      : 'GraySecondary'

  const finalColor = color.startsWith('Gray') ? `${color}--opaque` : color
  return `var(--${finalColor})`
}
